import { ref } from 'vue'
import { useHttp } from './useHttp'

export function useCotizacionesStats() {
  const { get, loading, error } = useHttp()

  const stats = ref({
    total: 0,
    pendientes: 0,
    aprobadas: 0,
    rechazadas: 0,
    totalMonto: 0,
    montoPromedio: 0,
    cotizacionesPorDia: [],
    prototiposMasVendidos: [],
    clientesTop: [],
    tendenciaSemanal: []
  })

  const fetchStats = async () => {
    try {
      await get('/cotizaciones/estadisticas')
      if (data.value) {
        stats.value = data.value
      }
    } catch (err) {
      console.error('Error fetching cotizaciones stats:', err)
      // Datos de ejemplo para desarrollo
      stats.value = {
        total: 156,
        pendientes: 23,
        aprobadas: 98,
        rechazadas: 35,
        totalMonto: 2456789.50,
        montoPromedio: 15748.65,
        cotizacionesPorDia: [
          { fecha: '2024-12-15', cantidad: 12 },
          { fecha: '2024-12-16', cantidad: 8 },
          { fecha: '2024-12-17', cantidad: 15 },
          { fecha: '2024-12-18', cantidad: 10 },
          { fecha: '2024-12-19', cantidad: 14 },
          { fecha: '2024-12-20', cantidad: 18 },
          { fecha: '2024-12-21', cantidad: 16 }
        ],
        prototiposMasVendidos: [
          { nombre: 'Caja Corrugado 30x30', cantidad: 45, monto: 456789 },
          { nombre: 'Etiqueta Premium', cantidad: 38, monto: 287650 },
          { nombre: 'Empaque Especial', cantidad: 32, monto: 398200 },
          { nombre: 'Caja Micro Corrugado', cantidad: 28, monto: 245600 },
          { nombre: 'Display Publicitario', cantidad: 25, monto: 512300 }
        ],
        clientesTop: [
          { nombre: 'Empresa ABC', cotizaciones: 28, monto: 678900 },
          { nombre: 'Industrias XYZ', cotizaciones: 22, monto: 545600 },
          { nombre: 'Comercial DEF', cotizaciones: 18, monto: 423100 }
        ],
        tendenciaSemanal: [
          { semana: 'Sem 1', cotizaciones: 35, monto: 456000 },
          { semana: 'Sem 2', cotizaciones: 42, monto: 523400 },
          { semana: 'Sem 3', cotizaciones: 38, monto: 487200 },
          { semana: 'Sem 4', cotizaciones: 41, monto: 590190 }
        ]
      }
    }
  }

  return {
    stats,
    fetchStats,
    loading,
    error
  }
}
